import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Evaluate from "@/pages/Evaluate";
import Results from "@/pages/Results";
import History from "@/pages/History";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Compare from "@/pages/Compare";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import Templates from "@/pages/Templates";
import Builder from "@/pages/Builder";
import InterviewPrep from "@/pages/InterviewPrep";
import MockInterview from "@/pages/MockInterview";
import InterviewPacks from "@/pages/InterviewPacks";
import InterviewPackDetail from "@/pages/InterviewPackDetail";
import LinkedInOptimizer from "@/pages/LinkedInOptimizer";
import AdminBuilder from "@/pages/AdminBuilder";
import RoleTemplate from "@/pages/RoleTemplate";
import Header from "@/components/Header";
import StickyTrialBanner from "@/components/StickyTrialBanner";
import ProtectedRoute from "@/components/ProtectedRoute";
import SiteVerification from "@/components/SiteVerification";
import { AuthProvider } from "@/contexts/AuthContext";

function AppRouter() {
  const location = useLocation();
  // Synchronously handle OAuth callback in URL fragment BEFORE other routes.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <SiteVerification />
      <StickyTrialBanner />
      <Header />
      <Routes>
        <Route path="/" element={<Landing variant="default" />} />
        <Route path="/free-resume-checker" element={<Landing variant="free-checker" />} />
        <Route path="/ats-resume-scanner" element={<Landing variant="ats-scanner" />} />
        <Route path="/linkedin-profile-audit" element={<Landing variant="linkedin-audit" />} />
        <Route path="/evaluate" element={<Evaluate />} />
        <Route path="/results/:id" element={<Results />} />
        <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/compare" element={<ProtectedRoute><Compare /></ProtectedRoute>} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/role/:slug" element={<RoleTemplate />} />
        <Route path="/builder" element={<Builder />} />
        <Route path="/interview/prep" element={<InterviewPrep />} />
        <Route path="/interview/mock" element={<ProtectedRoute><MockInterview /></ProtectedRoute>} />
        <Route path="/interview/packs" element={<InterviewPacks />} />
        <Route path="/interview/packs/:slug" element={<InterviewPackDetail />} />
        <Route path="/evaluate/linkedin" element={<LinkedInOptimizer />} />
        <Route path="/linkedin" element={<LinkedInOptimizer />} />
        <Route path="/admin/builder" element={<ProtectedRoute><AdminBuilder /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
